module.exports = "/_next/static/images/porter-fe2f441a6ca789b87c4c9bfa431bc2c9.png";